import { Pipe, PipeTransform } from '@angular/core';
import { isNil } from 'lodash-es';

import { NO_VALUE } from '../dash/dash.pipe';

@Pipe({
  name: 'msToSeconds',
})
export class MsToSecondsPipe implements PipeTransform {
  transform(milliseconds: number): string {
    const isNull = isNil(milliseconds);
    const isPositiveFiniteNumber =
      typeof milliseconds === 'number' && isFinite(milliseconds) && milliseconds > 0;

    if (isNull || !isPositiveFiniteNumber) {
      return NO_VALUE;
    }

    if (milliseconds < 1000) {
      return milliseconds + ' ms';
    } else {
      return milliseconds / 1000 + ' s';
    }
  }
}
